import { useStoreContext } from './useStoreContext'

export const useSupernovaEnabled = () => {
  const store = useStoreContext()
  return store.supernovaEnabled
}
